import React, { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { AccountCircle } from '@mui/icons-material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import MuiLink from '@mui/material/Link'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import HeaderAbout from './popups/HeaderAbout'
import HeaderPhone from './popups/HeaderPhone'
import HeaderMail from './popups/HeaderMail'
const HeaderTechnology = React.lazy(() => import('./popups/HeaderTechnology'))
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService'
import IconButton from '@mui/material/IconButton'
import MenuBar from './features/MenuBar'
const PntAlertIcon = React.lazy(() => import('../../containers/pages/alert/PntAlertIcon'))
import LocaleSelector from './features/LocaleSelector'
import { Tooltip } from '@mui/material'
import RoleSelector from './features/RoleSelector'
import { useTableQueryingContext } from '../app-context/TableQueryContext'
import useClasses from '../hooks/UseClasses'
import { useTheme } from '@mui/material'
import WrapperComponentControl from '@/components/permission-control/WrapperComponentControl'
import rolesConstants from '@/config/constants/RolesConstants'
import config from '@/config/env'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import SearchAndGo from './popups/SearchAndGo'
import { useAuth } from '../app-context/AuthContext'
import CtmCalculator from '@/containers/pages/customer/calculator/CtmCalculator'
const AssignedTeamPopup = React.lazy(() => import('../my-agent-panel/AssignedTeamPopup'))
import CustomSvgIcon from '../icons/builder/CustomSvgIcon'
import whatsappIcon from '../icons/builder/paths/whatsappIcon'
import { useEmbeddedMessaging } from '../app-context/EmbeddedMessagingContext'
import menuIcon from '../icons/builder/paths/menuIcon'
import { useIsFinalCustomer } from '@/config/utils/RolesUtils'

const { CRISP_CHAT, MULTILANGUGE, SF_ENABLED } = config

const HeaderDesktop = ({ standard = true }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()
  const { logout } = useAuth()
  const [anchorEl, setAnchorEl] = useState(null)
  const [openMenu, setOpenMenu] = useState(false)
  const [popupTechnology, setPopupTechnology] = useState(false)
  const isFinalCustomer = useIsFinalCustomer()
  const open = Boolean(anchorEl)
  const user = useSelector(({ login }) => login)
  const [openAssignedTeam, setOpenAssignedTeam] = useState(false)
  const [openChat, setOpenChat] = useState(false)
  const [chatResponse, setChatResponse] = useState(0)
  const { removeQuerying } = useTableQueryingContext()
  const [popupSearchAndGo, setPopupSearchAndGo] = useState(false)
  const em = useEmbeddedMessaging()

  const styles = () => ({
    imagen: {
      marginLeft: '2rem',
      marginRight: '3rem',
    },
    user: {
      color: 'white',
      float: 'right',
    },
  })

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClick = () => {
    removeQuerying()
    setOpenMenu(!openMenu)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  const classes = useClasses(styles)

  useEffect(() => {
    if (CRISP_CHAT !== undefined && CRISP_CHAT === 'true') {
      $crisp.push(['safe', true])
      if (user !== undefined && user.iduser !== undefined) {
        $crisp.push(['do', 'chat:show'])
        if (user.name !== undefined) {
          $crisp.push(['set', 'user:nickname', [user.name]])
        }
        if (user.email !== undefined) {
          $crisp.push(['set', 'user:email', [user.email]])
        }
      } else {
        $crisp.push(['on', 'chat:closed', closeChat])
        $crisp.push(['on', 'message:received', (message) => crispAnswer(message)])
        $crisp.push(['do', 'chat:hide'])
      }
    } else if (SF_ENABLED !== undefined && SF_ENABLED === 'true') {
      em.show()
      if (user.email !== undefined) {
        em.setHiddenPrechatFields({
          user_email: user.email,
        })
      }
    }
  }, [user.email, em])

  const toggleChat = () => {
    if (!openChat) {
      if (CRISP_CHAT !== undefined && CRISP_CHAT === 'true') {
        $crisp.push(['do', 'chat:show'])
        $crisp.push(['do', 'chat:open'])
      } else if (SF_ENABLED !== undefined && SF_ENABLED === 'true') {
        em.show()
      }
      setChatResponse(0)
    } else {
      closeChat()
    }
    setOpenChat(!openChat)
  }

  const closeChat = () => {
    if (CRISP_CHAT !== undefined && CRISP_CHAT === 'true') {
      $crisp.push(['do', 'chat:hide'])
    } else if (SF_ENABLED !== undefined && SF_ENABLED === 'true') {
      em.hide()
    }
  }

  const crispAnswer = () => {
    if (!openChat) {
      setChatResponse((currChatResponse) => currChatResponse + 1)
    }
  }

  return (
    <>
      <AppBar position="static" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, height: theme.desktopHeaderHeight }}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: `${theme.desktopHeaderHeight}px !important`,
            height: `${theme.desktopHeaderHeight}px`,
            padding: '0 1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <Grid style={{ display: 'flex', alignItems: 'center' }}>
            {user?.name && !isFinalCustomer && (
              <IconButton onClick={handleMenuClick}>
                <CustomSvgIcon svgString={menuIcon} fill={theme.palette.icon.light.color} />
              </IconButton>
            )}
            <MuiLink component={RouterLink} to={'/'} style={{ height: '100%', textDecoration: 'none' }}>
              <img
                srcSet={standard ? '/assets/logo.webp 900w' : '/assets/massol.webp 900w'}
                sizes="(max-width: 900px) 500px, 900px"
                className={classes.imagen}
                style={{ width: '8rem' }}
                src={standard ? '/assets/logo.webp 900w' : '/assets/massol.webp 900w'}
              />
            </MuiLink>
          </Grid>
          <Grid style={{ alignItems: 'center', display: 'flex', lineHeight: '0.5' }}>
            {user.name !== undefined && (
              <Grid
                container
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'right',
                  gap: '1rem',
                }}>
                <WrapperComponentControl
                  rolesAccess={[
                    rolesConstants.ROLE_MERCHANT,
                    rolesConstants.ROLE_MERCHANTCOM,
                    rolesConstants.ROLE_COMMERCIAL,
                    rolesConstants.ROLE_OPERATOR,
                    rolesConstants.ROLE_ACCOUNTANT,
                    rolesConstants.ROLE_ADMIN,
                  ]}>
                  <CtmCalculator />
                </WrapperComponentControl>
                <WrapperComponentControl
                  rolesAccess={[
                    rolesConstants.ROLE_MERCHANT,
                    rolesConstants.ROLE_MERCHANTADMIN,
                    rolesConstants.ROLE_MERCHANTCOM,
                  ]}>
                  <Tooltip title={t('HEADER.INSENTERPRISE.ASSIGNED.TEAM')}>
                    <IconButton sx={{ padding: 0 }} onClick={() => setOpenAssignedTeam(true)}>
                      <CustomSvgIcon
                        svgString={whatsappIcon}
                        fill={theme.palette.icon.light.color}
                        sx={{
                          color: theme.palette.icon.light.color,
                          [theme.breakpoints.down('md')]: {
                            display: 'none !important',
                          },
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </WrapperComponentControl>
                <WrapperComponentControl
                  rolesAccess={[
                    rolesConstants.ROLE_MERCHANT,
                    rolesConstants.ROLE_MERCHANTCOM,
                    rolesConstants.ROLE_MERCHANTADMIN,
                    rolesConstants.ROLE_COMMERCIAL,
                    rolesConstants.ROLE_OPERATOR,
                    rolesConstants.ROLE_ADMIN,
                  ]}>
                  <>
                    <HomeRepairServiceIcon
                      onClick={() => setPopupTechnology(true)}
                      sx={{
                        cursor: 'pointer',
                        [theme.breakpoints.down('md')]: {
                          display: 'none !important',
                        },
                      }}
                    />
                    <HeaderTechnology open={popupTechnology} setOpen={setPopupTechnology} />
                  </>
                </WrapperComponentControl>
                <WrapperComponentControl
                  rolesAccess={[
                    rolesConstants.ROLE_COMMERCIAL,
                    rolesConstants.ROLE_OPERATOR,
                    rolesConstants.ROLE_ACCOUNTANT,
                  ]}>
                  <Tooltip title={t('SEARCHGO.SEARCHER')}>
                    <SearchOutlinedIcon
                      onClick={() => setPopupSearchAndGo(true)}
                      sx={{
                        cursor: 'pointer',
                        [theme.breakpoints.down('md')]: {
                          display: 'none !important',
                        },
                      }}
                    />
                  </Tooltip>
                  <SearchAndGo open={popupSearchAndGo} setOpen={setPopupSearchAndGo} />
                </WrapperComponentControl>
                <WrapperComponentControl rolesAccess={[rolesConstants.ROLE_MERCHANT]}>
                  <PntAlertIcon />
                </WrapperComponentControl>
                {user?.rolesPermitted.length > 1 && <RoleSelector />}
                {MULTILANGUGE !== undefined && MULTILANGUGE === 'true' && <LocaleSelector />}
                <Button
                  sx={{
                    padding: '12px',
                    color: 'white',
                    fontSize: 'large',
                    gap: '0.5rem',
                    lineHeight: '0.5',
                    [theme.breakpoints.down('md')]: {
                      display: 'none !important',
                    },
                  }}
                  className={classes.user}
                  onClick={handleClick}>
                  <b>{user.name}</b>
                  <AccountCircle
                    style={{
                      color: 'white',
                    }}
                    fontSize={'medium'}
                  />
                </Button>
              </Grid>
            )}
          </Grid>
          <Menu
            id="header"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            slotProps={{ paper: { style: { maxHeight: 48 * 4.5 } } }}>
            <HeaderMail user={user} />
            <HeaderPhone />
            <HeaderAbout />
            <MenuItem onClick={() => handleLogout()}>
              <ListItemIcon>
                <ExitToAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={t('HEADER.LOGOUT')} />
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {openMenu && <MenuBar open={openMenu} setOpen={handleMenuClick} headerHeight={theme.desktopHeaderHeight} />}
      <AssignedTeamPopup open={openAssignedTeam} setOpen={setOpenAssignedTeam} />
    </>
  )
}

export default HeaderDesktop
